var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 127,
    viewBox: "0 0 228 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7168 122.894C11.3091 125.089 13.3981 126.711 15.8843 126.711H203.965C217.226 126.711 227.976 116.457 227.976 103.809V12.8375C227.976 10.378 226.147 8.32606 223.715 7.85156C223.869 8.75853 223.956 9.68693 223.972 10.632C224.77 11.0716 225.308 11.8947 225.308 12.8375V103.809C225.308 115.052 215.752 124.166 203.965 124.166H15.8843C14.8969 124.166 14.0347 123.654 13.5734 122.894H10.7168Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8457 118.021C6.43801 120.217 8.52705 121.84 11.0132 121.84H203.096C214.146 121.84 223.105 113.291 223.105 102.746V7.9118C223.105 5.53925 221.404 3.54571 219.103 2.98047V5.70653C219.9 6.14672 220.437 6.96947 220.437 7.9118V102.746C220.437 106.592 219.061 110.133 216.754 112.943C215.935 114.038 214.93 114.998 213.782 115.779C210.837 117.981 207.127 119.294 203.096 119.294H11.0132C10.0258 119.294 9.1636 118.782 8.70233 118.021H5.8457Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBorder);
export default __webpack_public_path__ + "static/media/gold-border.2e50ef03a9e6307bf38b1f6ff84937d3.svg";
export { ForwardRef as ReactComponent };